<template>
	<div id="Group">
		<!-- <div class="row" v-if="alertRemove">
			<div class="col-12 text-left">
				<p style="color: #FF4040">É necessário ao menos uma foto na galeria.</p>
			</div>
		</div> -->
		<div class="text-center mx--2 align-items-top d-flex flex-column align-items-end">
			<div class="control-buttons-slogan">
				<span 
					v-b-tooltip.hover title="Editar título da galeria"
					class="control-buttons" @click="showSlogan()">
					<i class="fal fa-pencil-alt"></i>
				</span>
			</div>

			<div v-if="!checkSlogan || ok" class="col-12 text-left mb-3">
				<label class="default-label" for="Slogan" v-if="postType == 'home'">Texto do Slide</label>
				<label class="default-label" for="Slogan" v-else>Título da Galeria ou slogan</label>
				<input
					type="text"
					class="form-control"
					placeholder="Escolha um slogan para a Galeria"
					v-model="slogan"
					@blur="updateFrameContentPictures"
				/>
			</div>

			<div class="row mb-3 mr-2" v-if="arrayImages.length > 2">
				<select
					v-model="sortType"
					@change="filteredItems(gallery,sortType)"
					class="select pr-1 bg-transparent form-control"
					id="inputGroupSelect01"
				>
					<option value="CHRONODESC">
						Mais Novas
					</option>
					<option value="CHRONOASC">
						Mais Antigas
					</option>
					<option value="ALPHABASC">
						Ordem Alfabetica A-Z
					</option>
					<option value="ALPHABDESC">
						Ordem Alfabetica Z-A
					</option>
					<option value="CUSTOM">
						Personalizada(arraste)
					</option>
				</select>
			</div>

			<button
				v-b-tooltip.hover
				title="Adicionar mídia"
				:class="['btn-add-file']"
				@click="openMediaManager()"
			>
				<i class="fal fa-upload"></i>
			</button>

			<div class="col-12">
				<draggable
					class="row"
					:force-fallback="true"
					handle=".drag"
					v-model="arrayImages"
					@change="updateFrameContentPictures('CUSTOM')"
				>
					<div
						:class="['p-1', itemsPerLine != null ? itemsPerLineClass : colsItemClass]"
						v-for="(item, index) in arrayImages"
						:key="index+item.image.url"
					>
						<div class="picture-gallery text-center cursor-pointer">
							<div @click="editItem(item, index)" class="picture-gallery--item d-flex">
								<BaseImage
									:customClass="'img-galery rounded'"
									:source="item.image.url"
									:fitIn="'300x300'"
								/>

								<div v-if="item.type == 'video' " class="icon-play">
									<img src="../../assets/img/icons/icon-play.svg" alt="video">
								</div>
							</div>

							<div class="position-absolute ps-b-0 ps-l-0 m-2">
								<p class="gallery-item-title text-left text-white overflow-hidden">
									{{ item.title }}
								</p>
							</div>

							<div
								v-b-tooltip
								title="Mover mídia"
								class="area-action-move drag"
							>
								<button class="btn-gallery-action float-left">
									<i class="fal fa-arrows font-18"></i>
								</button>
							</div>

							<b-dropdown class="dropdown-gallery"  variant="link" toggle-class="text-decoration-none" no-caret>
								<template #button-content>
									<div class="options-dropdown">
										<i class="fa fa-ellipsis-h font-18"></i>
										
										<span class="sr-only">Opções</span>
									</div>
								</template>

								<b-dropdown-item @click="editItem(item, index)">
									<i class="fal fa-pencil-alt font-14 mr-1"></i>

									Editar mídia
								</b-dropdown-item>
								

								<b-dropdown-item @click="changeImageFromGallery(index)">
									<i class="fal fa-sync font-14 mr-1"></i>

									Trocar mídia
								</b-dropdown-item>

								<b-dropdown-item @click="removePhotoFromGalery(index)">
									<i class="fal fa-trash-alt font-14 mr-1"></i>

									Excluir
								</b-dropdown-item>
							</b-dropdown>

							<div class="actions-gallery">
								<button
									v-b-tooltip
									title="Trocar mídia"
									class="btn-gallery-action d-none d-md-block"
									@click="changeImageFromGallery(index)"
								>
									<i class="fal fa-sync font-14"></i>
								</button>

								<button
									v-b-tooltip
									title="Excluir mídia"
									class="btn-gallery-action d-none d-md-block"
									@click="removePhotoFromGalery(index)"
								>
									<i class="fal fa-trash-alt font-14"></i>
								</button>
							</div>
						</div>
					</div>
				</draggable>
			</div>
		</div>
		<b-modal
			ref="editItemModal"
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-footer
			hide-header-close
			modal-class="bg-white"
			content-class="no-border"
		>
			<div class="row">
				<div class="col-12">
					<h4>Editar item</h4>
				</div>
				<div class="col-12 text-center">
					<div v-if="showSetPoint(activeItem.data.type)" class="d-flex flex-column align-items-center">
						<p class="mb-2">Selecione o ponto focal das imagens para mobile</p>
						<div @click.stop.prevent="setPoint($event,activeItem)" style="width: fit-content" class="position-relative">
							<BaseImage v-if="activeItem.data.image"
								:customClass="'img-fluid rounded pointer'"
								:source="activeItem.data.image.url"
								:fitIn="'0x300'"
							/>
							<i 
								class="fal fa-square crosshairs"
								:style="`left:${activeItem.data.focalPoint.x}%; top:${activeItem.data.focalPoint.y}%;`">
							</i>
						</div>
					</div>
					<div class="d-none" v-if="activeItem.data.type == 'image'" >
						<div class="col-6 text-left">
							<label class="default-label" for="edit-item-modal-title"
								>Focal Ponto da esquerda</label
							>
							<div class="d-flex">
								<input
									class="form-control"
									id="edit-item-modal-title"
									type="number" 
									min="1" 
									max="100"
									style="width: 35px;"
									v-model="activeItem.data.focalPoint.x"
								/>
								<span class="form-control">%</span>
							</div>
						</div>
						<div class="col-6 text-left">
							<label class="default-label" for="edit-item-modal-title"
								>Focal Ponto da topo</label
							>
							<div class="d-flex">
								<input
									class="form-control "
									type="number" 
									min="1" 
									max="100"
									style="width: 35px;"
									id="edit-item-modal-title"
									v-model="activeItem.data.focalPoint.y"
								/>
								<span class="form-control">%</span>
							</div>
						</div>
					</div>
				</div>
				<template>				
					<div class="col-12 form-group">
						<label 
							class="default-label" 
							for="edit-item-modal-title"
						>
							Título
						</label>
						<input
							class="form-control"
							type="text"
							id="edit-item-modal-title"
							v-model="activeItem.data.title"
						/>
					</div>
					<div class="col-12 form-group">
						<label class="default-label" for="edit-item-modal-title"
							>Resumo</label
						>
						<textarea
							rows="4"
							class="form-control"
							type="text"
							id="edit-item-modal-subtitle"
							v-model="activeItem.data.subtitle"
							maxlength="350"
						/>
					</div>
					<div class="col-12 form-group" v-if="checkPostType()">
						<template v-if="activeItem.data.target == '_scroll'">
							<label  class="default-label" for="edit-item-modal-href"
								>Escolha o card de destino</label
							>
							<select
								class="form-control"
								id="edit-item-modal-target"
								v-model="activeItem.data.href"
							>
								<option 
									:value="item.component.indexOf('maincontent') > -1 ? `#${item.frameId}` : `/?scroll_to=${item.frameId}`"
									v-for="item, index in contentPost"
									:key="item.frameId"
									>
										{{`${index}-${item.component.split('-')[0]}`}}
									</option>
							</select>
						</template>
						<template v-else >
							<label class="default-label" for="edit-item-modal-href"
								>URL de destino</label
							>
							<input
								:disabled="activeItem.data.type === 'page'"
								class="form-control"
								type="text"
								id="edit-item-modal-href"
								v-model="activeItem.data.href"
							/>
						</template>
					</div>
					<div class="col-12 form-group" v-if="checkPostType()">
						<label class="default-label" for="edit-item-modal-target"
							>Abrir em</label
						>
						<select
							class="form-control"
							id="edit-item-modal-target"
							v-model="activeItem.data.target"
						>
							<option value="_self">Mesma aba</option>
							<option value="_blank">Nova aba</option>
							<option value="_scroll">Rolagem</option>
						</select>
					</div>
					<div class="col-12" v-if="checkPostType()">
						<CheckBox 
							label="Exibir botão" 
							:visible="activeItem.data.button" 
							@onCheck="activeItem.data.button = $event"/>
						<div
							class="col-12 form-group"
							v-if="activeItem.data.button == true"
						>
							<label
								class="default-label"
								for="edit-item-modal-buttonText"
								>Texto no botão</label
							>
							<input
								class="form-control"
								type="text"
								id="edit-item-modal-buttonText"
								v-model="activeItem.data.buttonText"
							/>
							<div class="d-flex align-items-center justify-content-around my-3">
								<span class="default-label">Botões Extra</span>
								<button 
									v-if="activeItem.data.buttonList && activeItem.data.buttonList.length < 2"
									class="btn btn-large btn-primario "
									@click="addNewButton(activeItem.data.buttonList)"> Adicionar Botão
								</button>
							</div>
							<div v-if="activeItem.data.buttonList && activeItem.data.buttonList.length > 0">
								<div 
									class="extra-button"
									v-for="button,index in activeItem.data.buttonList"
									:key="'button'+index"
									:Id="button.buttonText">
										<div    
											class="col-12 form-group"
										>
											<label
												class="default-label"
												for="edit-item-modal-buttonText"
												>Texto no botão</label
											>
											<input
												class="form-control"
												type="text"
												id="edit-item-modal-buttonText"
												v-model="button.buttonText"
											/>
										</div>
										<CheckBox 
											label="Exibir botão" 
											:visible="button.button" 
											@onCheck="button.button = $event"/>
										<div class="col-12 form-group">
											<label class="default-label" for="edit-item-modal-href"
												>URL de destino</label
											>
											<input
												class="form-control"
												type="text"
												id="edit-item-modal-href"
												v-model="button.href"
											/>
										</div>
										<div class="col-12 form-group">
											<label class="default-label" for="edit-item-modal-target"
												>Abrir em</label
											>
											<select
												class="form-control"
												id="edit-item-modal-target"
												v-model="button.target"
											>
												<option value="_self">Mesma aba</option>
												<option value="_blank">Nova aba</option>
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<CheckBox
						v-if="activeItem.data.type == 'video' "
						label="Reproduzir automaticamente. (mudo)" 
						:visible="activeItem.data.autoplay" 
						@onCheck="activeAutoPlay($event)"/>
					<CheckBox
						v-if="activeItem.data.type == 'video' "
						label="Ampliar ao clicar. (com áudio) " 
						:visible="activeItem.data.expand"
						@onCheck="activeExpand($event)"/>
					<div class="col-12 moreSettings" v-if="activeItem.data.type == 'video'">
						<div v-if="!moreSettings">  
							<i class="fas fa-plus-circle" @click="moreSettings = !moreSettings"></i>
						</div>
						<div v-else class="d-flex flex-column">  
							<i class="fas fa-minus-circle" @click="moreSettings = !moreSettings"></i>
							<label class="default-label" for="Slogan">Vídeo mobile</label>
							<input
								type="text"
								class="form-control"
								placeholder="Link do vídeo mobile"
								v-model="activeItem.data.embedMobile"
							/>
						</div>
					</div>
				<div class="col-6 text-left mt-5">
					<button
						class="btn btn-extra-large btn-secondary"
						@click="cancelUpdateActiveItem"
					>
						Cancelar
					</button>
				</div>
				<div class="col-6 text-right mt-5">
					<button
						class="btn btn-extra-large btn-primario"
						@click="updateActiveItem"
					>
						Salvar
					</button>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import CheckBox from "../atoms/checkBox.vue"
	import FileAdd from "../molecules/FileAdd.vue";
	import BaseImage from "@/components/atoms/BaseImage";
	import Draggable from "vuedraggable";
	import moment from "moment";
	import { mapState } from "vuex";

	export default {
		data() {
			return {
				arrayImages: [],
				moreSettings: false,
				galleryRequestedMediaManager: null,
				activeItem: {
					index: null,
					data: {},
				},
				originalItem:null,
				slogan: "",
				checkSlogan: false,
				ok : false,
				clientWidth: 0,
				clientHeight:0,
				gallery:[],
				sortType: 'CUSTOM'
			};
		},
		props: {
			galleryData: {
				type: Object,
			},
			postType: {
				type: String,
			},
			cols: {
				type: Number,
			},
			itemsPerLine: {
				type: Number | String | null,
				default: null,
			},
		},
		components: {
			BaseImage,
			Draggable,
			FileAdd,
			CheckBox
		},
		computed: {
			...mapState("dashboardModule", {
			contentPost: (state) => state.activePost.content,
			}),
			colsItemClass() {
				if (this.cols >= 3 && this.cols <= 5) return "col-6";

				if (this.cols >= 6 && this.cols <= 8) return "col-3";

				if ((this.cols >= 9 && this.cols <= 12) || this.cols == 99) return "col-2";

				return "col-12";
			},
			itemsPerLineClass() {
				const classMap = {
					1: "col-12",
					2: "col-6",
					3: "col-4",
					4: "col-3",
					6: "col-2"
				};

				return classMap[parseInt(this.itemsPerLine)] || "col-4";
			},
		},
		mounted() {
			this.gallery = this.galleryData.items
			this.arrayImages = [...this.arrayImages, this.gallery].flat()
			// checa se alguma imagem tem texto, se tiver, invalida o slogan
			for (var i = this.arrayImages.length - 1; i >= 0; i--) {
				// verifica se nao é vazio
				if(!!this.arrayImages[i].title) {
					this.checkSlogan = true
				}
			}

			this.slogan = this.galleryData.text

			// se o slogan for vazio e o check false, deixar o campo escondido
			if (!this.slogan && this.checkSlogan === false) {
				this.checkSlogan = true
			} 

		},
		watch:{
			arrayImages: {
				handler: function (val, oldVal) {
					let gallery = JSON.parse(JSON.stringify(this.arrayImages))
					let galleryArray = []
					for (let i = 0; i < gallery.length; i++) {
						const element = gallery[i];
						if(i !== 0){
							galleryArray.push(element)
						}
					}
					this.gallery = galleryArray
				},
				deep: true,
			},
		},
		methods: {
			/*
			*	FUNÇÃO CRIADA PARA EMITIR O EVENTO DE ALTERAR CADA IMAGEM
			*	INDIVIDUALMENTE DE UMA GALERIA
			*/
			changeImageFromGallery(indexPicture) {
				// PEGANDO COMPONENTE PAI(FRAME CONTAINER) - Normalmente localizado no PostEditor
				const frameContainer = this.$parent;

				// EMITINDO EVENTO PELO FRAME CONTAINER DIRETAMENTE PARA O POST EDITOR,
				// PASSANDO O INDEX DA IMAGEM QUE ESTÁ SENDO ALTERADA
				frameContainer.$emit('changeImageFromGallery', indexPicture)
			},
			/* fix para nao mostrar botao e url quando nao for uma home ou about
			* quando na home vem home, quando no about vem section, e maincontent vem post
			*
			* TODO: Posteriormente vai ter que verificar se é gallery-carousel ou isotope,
			* ou melhor colocar o botao no lightbox se tiver
			*/
			checkPostType() {
				return this.postType != 'post' ? true : false;
			},
			addNewButton(listButtons){
				let newButton = {
					"href": null,
					"target": "_self",
					"button": true,
					"buttonText": ""
				}
				if(listButtons.length < 2) listButtons.push(newButton)
			},
			// Select para ordernar galleria
			filteredItems(items,sortType) {
				const sortingFunctions = {
					CHRONOASC: (item1, item2) => {
						if (
							moment(item1.image.createdAt, "DD-MM-YYYY HH:mm:ss").toDate() >
							moment(item2.image.createdAt, "DD-MM-YYYY HH:mm:ss").toDate()
						)
							return 1;
						if (
							moment(item1.image.createdAt, "DD-MM-YYYY HH:mm:ss").toDate() <
							moment(item2.image.createdAt, "DD-MM-YYYY HH:mm:ss").toDate()
						)
							return -1;

						return parseInt(item1.id) > parseInt(item2.id) ? 1 : -1;
					},
					CHRONODESC: (item1, item2) => {
						if (
							moment(item1.image.createdAt, "DD-MM-YYYY HH:mm:ss").toDate() <
							moment(item2.image.createdAt, "DD-MM-YYYY HH:mm:ss").toDate()
						)
							return 1;
						if (
							moment(item1.image.createdAt, "DD-MM-YYYY HH:mm:ss").toDate() >
							moment(item2.image.createdAt, "DD-MM-YYYY HH:mm:ss").toDate()
						)
							return -1;

						return parseInt(item1.id) < parseInt(item2.id) ? 1 : -1;
					},
					ALPHABDESC: (item1, item2) => {
						const i1 = item1.image.url.lastIndexOf('/') + 1
						const i2 = item2.image.url.lastIndexOf('/') + 1
						const innerItem1 = item1.image.url.slice(i1).toLowerCase().trim()
						const innerItem2 = item2.image.url.slice(i2).toLowerCase().trim()
						if (innerItem1 > innerItem2 || !innerItem2)
							return -1;
						if (innerItem1 < innerItem2 || !innerItem1)
							return 1;
						return 0;
					},
					ALPHABASC: (item1, item2) => {
						const i1 = item1.image.url.lastIndexOf('/') + 1
						const i2 = item2.image.url.lastIndexOf('/') + 1
						const innerItem1 = item1.image.url.slice(i1).toLowerCase().trim()
						const innerItem2 = item2.image.url.slice(i2).toLowerCase().trim()
						if (innerItem1 < innerItem2 || !innerItem2)
							return -1;
						if (innerItem1 > innerItem2 || !innerItem1)
							return 1;
						return 0;
					}
				};
				const itemsSort = items.sort(sortingFunctions[sortType])
				this.arrayImages = [this.arrayImages[0], itemsSort].flat()
				this.updateFrameContentPictures()
				return itemsSort;
			},
      showSetPoint(frameType) {
        const allowSetingsFrames = ["image", "video", "page"];
        if (allowSetingsFrames.some((item) => item === frameType)) {
          return true;
        }
        return false;
      },
			setPoint(e,item){
					let clickInX = e.offsetX;
					let clickInY = e.offsetY;
					var xOrigin = e.target.clientWidth;
					var yOrigin = e.target.clientHeight;
					item.data.focalPoint.x = Math.round((clickInX/xOrigin)*100)
					item.data.focalPoint.y = Math.round((clickInY/yOrigin).toFixed(2)*100)
			},
			activeAutoPlay(event){
				this.activeItem.data.autoplay = event;
			},
			activeExpand(event){
				this.activeItem.data.expand = event;
			},
			showSlogan(){
				this.ok = !this.ok
			},
			// Função para remover o Observer da array
			// Forma de resolver o problema de relacionamento de uma array a outra
			setValor(newVal){
				const value = JSON.parse(JSON.stringify(newVal))
				return value
			},
			// Função para abrir o modal de edição
			editItem(item, index) {
				this.activeItem.index = index;
				const editItem = this.setValor(this.arrayImages[this.activeItem.index])
				this.originalItem = this.setValor(editItem)
				this.activeItem.data = editItem
				this.$refs["editItemModal"].show();
			},
			// Limpa a variavel de activeItem
			clearActiveItem() {
				this.activeItem.index = null;
				this.activeItem.data = {};
			},
			closeUpdateModal() {
				this.$refs["editItemModal"].hide();
			},
			updateActiveItem() {
				if (this.activeItem.data.target === '_scroll') this.activeItem.data.target = '_self'
				this.arrayImages[this.activeItem.index] = this.setValor(this.activeItem.data);
				this.updateFrameContentPictures();
				this.clearActiveItem();
				this.closeUpdateModal();
			},
			cancelUpdateActiveItem() {
				this.clearActiveItem();
				this.closeUpdateModal();
			},
			removePhotoFromGalery(index) {
				if (this.arrayImages.length > 1) {
					this.$bvModal
						.msgBoxConfirm("Deseja remover este item da galeria?", {
							//title: "Sair do editor?",
							modalClass: "full-white",
							size: "md",
							buttonSize: "sm",
							cancelVariant: "danger",
							okTitle: "Excluir",
							cancelTitle: "Cancelar",
							footerClass: "p-2",
							hideHeaderClose: true,
							centered: true,
						})
						.then((value) => {
							if (value) {
								this.arrayImages.splice(index, 1);
								this.updateFrameContentPictures();
							}
						});
				} else {
					this.$bvModal.msgBoxOk(
						"Você precisa ter ao menos um item na galeria",
						{
							modalClass: "full-white text-center",
							size: "md",
							okTitle: "Ok",
							hideHeaderClose: true,
							centered: true,
							footerClass: "justify-content-center",
						}
					);
				}
			},
			// seta a nova array de imagens e emitt para o FrameContainer.vue atualizar o contentPost
			updateFrameContentPictures(sortType) {
				if(sortType && sortType == 'CUSTOM'){
					this.sortType = 'CUSTOM' 
				}
				this.$set(this.arrayImages, this.activeItem.index , this.activeItem.data);
				let frameContainer = {
					text: this.slogan,
					items: this.arrayImages.filter(item => item.type != "button"),
				};
				this.$emit("updateContent", frameContainer);
			},
			openMediaManager() {
				this.$emit("openMediaManager");
			},
		},
	};
</script>

<style>
	.picture-gallery {
		position: relative;
	}

	.picture-gallery .picture-gallery--item {
		position: relative;
		filter: brightness(0.8);
	}

	.actions-gallery {
		padding: 0.375rem 0.75rem;
		position: absolute;
		bottom: 0;
		right: 0;
		display: flex;
	}

	.area-action-move.drag {
		padding: 0.42rem 0.75rem;
		cursor: move;
		width: 50%;
		position: absolute;
		top: 0;
		left: 0;
	}

	.area-action-move .btn-gallery-action{
		cursor: move;
		height: 2rem;
		width: 2rem;
	}

	.dropdown-gallery {
		position: absolute;
		top: 0;
		right: 0;
	}

	.btn-gallery-action {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: none;
		background: transparent;
		color: #fff;
	}

	.btn-gallery-action:hover {
		filter: brightness(0.9);
	}

	.options-dropdown {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 2rem;
		width: 2rem;
		color: #fff;
	}

	.options-dropdown:hover {
		filter: brightness(0.9);
	}

	.moreSettings i{
		font-size: 20px;
		color: var(--main-color);
	}
	
	.moreSettings i{
		padding: 10px 0;
		cursor: pointer;
	}

	.icon-play{
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		opacity: 0.8;
	}

	.icon-play img{
		width: 50%;
	}

	.hover-shadow {
		transition: 0.3s;
	}

	.post-item:focus .control-buttons-slogan, .post-item:hover .control-buttons-slogan {
		opacity: 1;
	}

	.control-buttons-slogan {
		width: 100%;
		display: flex;
		position: relative;
		justify-content: flex-start;
		top: -15px;
		opacity: 0;
	}

	.hover-shadow:hover {
		box-shadow: 0px 5px 15px #0000002e;
		border-radius: 4px;
		cursor: pointer;
	}

	.img-galery {
		object-fit: cover;
		max-height: 150px;
		width: 100%;
		object-position: center;
	}

	.btn-outline-primario {
		background-color: #fff;
		border: 1px solid rgba(93, 64, 255, 0.5);
		transition: all 300ms;
	}

	.btn-outline-primario i {
		color: rgba(93, 64, 255, 0.5);
	}

	.btn-outline-primario:hover {
		background-color: rgba(93, 64, 255, 0.5);
		border: 1px solid rgba(93, 64, 255, 0.5);
	}

	.btn-outline-primario:hover i {
		color: #fff;
	}

	@media (max-width: 425px) {
		.next,
		.prev {
			display: none !important;
		}
	}

	.no-border {
		border: none !important;
	}

	.add-item-gallery {
		font-size: 30px;
		border: 2px dashed #6828e83d;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
		color: var(--main-color);
		transition: all 0.2s ease;
	}

	.default-label {
		color: rgba(0, 0, 0, 0.32);
		font-weight: 700;
		font-size: 0.6rem;
	}

	.control-buttons {
		cursor: pointer;
		background: #f8f8fa;
		width: 32px;
		height: 32px;
		border-radius: 2rem;
		float: left;
		position: relative;
		margin-left: 0.5rem;
		color: #1b1b1b;
		transition: all 0.2s ease;
	}

	.control-buttons i {
		position: absolute;
		transform: translate(-50%, -50%);
		top: 50%;
		left: 50%;
	}

	.control-buttons:hover {
		color: #fff;
		background: var(--main-color);
	}

	span.default-label{
		font-size: 16px;
	}

	.extra-button{
		border: 2px solid #dddddd;
		padding: 10px;
		margin: -2px;
	}

	.gallery-item-title{
		font-size: .7rem;
	    line-height: .8rem;
	    text-overflow: ellipsis;
	    display: -webkit-box;
	    -webkit-line-clamp: 2;
	    -webkit-box-orient: vertical;
	}

	@media screen and (max-width: 576px) {
		.options-dropdown {
			height: 1rem;
			width: 1rem;
		}

		i.fa-ellipsis-h {
			font-size: 0.5rem;
		}

		.options-dropdown-container > button {
			padding: 0.2em 0.2em!important;
		}
	}
</style>
<style scoped>
	.crosshairs{
		position: absolute;
		font-size: 54px;
		pointer-events: none;
		transform: translate(-27px, -27px);
		z-index: 100;
		color:white;
	}

	.btn-add-file {
		z-index: 99;
		left: -12px;
		top: 30%;
		transform: translateY(30%);
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		height: 3.5rem;
		width: 3.5rem;
		background: #fff;
		border: 1px solid #ddd;
		border-radius: 8px;
		padding: 0.5rem 1rem;
		color: #1b1b1b;
		transition: all 0.2s ease;
	}
	
	.btn-add-file i {
		font-size: 1rem;
	}

	.btn-add-file:hover {
		color: #fff;
		background: var(--main-color);
		border: 1px solid var(--main-color);
	}
</style>


// WEBPACK FOOTER //
// src/components/molecules/GalleryPictures.vue